"use client";

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import Image from 'next/image';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '/homepage', label: 'Home' },
    { href: '/services', label: 'Services' },
    { href: '/contact', label: 'Contact Us' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/80 backdrop-blur-md border-b border-border' :'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/homepage" className="flex items-center hover:opacity-80 transition-opacity">
          <Image
            src="/assets/images/armadaLOGOFINA-WEB-1770012963178.png"
            alt="Armada MSP Logo"
            width={180}
            height={60}
            priority
            className="h-12 w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-12">
          {navLinks?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              className={`label-micro transition-colors relative ${
                pathname === link?.href
                  ? 'text-primary' :'text-muted-foreground hover:text-primary'
              }`}
            >
              {link?.label}
              {pathname === link?.href && (
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-primary" />
              )}
            </Link>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden lg:flex items-center gap-6">
          <Link
            href="/contact"
            className="px-8 py-3 bg-primary text-primary-foreground rounded-full label-micro hover:scale-105 transition-all btn-glow"
          >
            Get Started
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-white"
          aria-label="Toggle menu"
        >
          <Icon name={isMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
        </button>
      </nav>
      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-20 bg-black/95 backdrop-blur-lg z-40">
          <div className="flex flex-col items-center justify-center h-full gap-8">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                onClick={() => setIsMenuOpen(false)}
                className={`text-2xl font-bold uppercase tracking-tight transition-colors ${
                  pathname === link?.href
                    ? 'text-primary' :'text-white hover:text-primary'
                }`}
              >
                {link?.label}
              </Link>
            ))}
            <Link
              href="/contact"
              onClick={() => setIsMenuOpen(false)}
              className="px-12 py-4 bg-primary text-primary-foreground rounded-full label-micro hover:scale-105 transition-all btn-glow mt-8"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}